marked = require("marked")
class LessonMenuView extends Backbone.View
  events:
    "iostap #lesson-menu-exit": "exit"
    "iostap #lesson-menu-go-back": "back"
    "iostap #lesson-menu-restart": "restart"
    "iostap #lesson-menu-cancel": "close"

  initialize: (@options) ->
    @pageNumber = @el.querySelector("#lesson-menu-page-count")
    @el.setAttribute("aria-hidden", "true")

  open: ->
    @el.classList.add("active")
    @el.setAttribute("aria-hidden", "false")

    for child in @el.parentNode.childNodes
      if child.getAttribute("id") isnt "lesson-menu"
        child.setAttribute("hidden", "hidden")

  close: ->
    @el.classList.remove("active")
    @el.setAttribute("aria-hidden", "true")

    for child in @el.parentNode.childNodes
      if child.getAttribute("id") isnt "lesson-menu"
        child.removeAttribute("hidden")
    

  exit: ->
    @options.exit()
    Backbone.Events.trigger "application-exit"
    Application.publish("event:menu-exit") {}

  back: ->
    @options.back()
    @close()

  restart: ->
    @options.restart()
    @close()

  updateStyle: ({ colors, background } = {}) ->
    image = if background? then "url(#{background})" else ""
    { text, background } = colors or {}

    @el.style.backgroundImage = image
    @el.style.backgroundColor = background
    @el.style.color = text

  setPage: (index) ->
    total = @pageNumber.dataset.total
    if @options.isQuiz
      @pageNumber.innerHTML = marked(
        i18n("menu.brainboost-page-count", { index: index + 1, total })
      )
    else 
      @pageNumber.innerHTML = marked(
        i18n("menu.page-count", { index: index + 1, total })
      )

    $(@el).removeClass (index, classes) ->
      return (classes.match(/page-\d+/g) || []).join(" ")
    @el.classList.add("page-#{@currentIndex = index}")

module.exports = LessonMenuView